export const TestIds = {
  ResponsivePopupContainerBg: 'responsivePopupContainerBg',
  ResponsivePopupContainerOverlay: 'responsivePopupContainerOverlay',
} as const;
